import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import InsertWorker from './InsertWorker';
import WorkersForm from './WorkersForm';
import WorkersTable from './WorkersTable';
import operationsHelpers from '../../helpers/operations';


function Workers(props) {

    const [name, setName] = useState('');
    const [status, setStatus] = useState(null);
    const [workers, setWorkers] = useState([]);
    const [openInsertWorkerPopup, setOpenInsertWorkerPopup] = useState(false);
    const [openEditWorkerPopup, setOpenEditWorkerPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const status_options = [
        {value: 'Active', name: 'Active'},
        {value: 'Inactive', name: 'Inactive'},
    ];

    useEffect(async () => {
        await getWorkers();
    }, []);

    const getWorkers = async () => {
        props.setLoading(true);
        try {
            const payload = {
                name: name ? name : null,
                status: status ? status : null
            };
            const res = await operationsHelpers.getWorkers(payload, props.company, props.token);
            setWorkers(res);

        } catch(err) {
            console.log('getWorkers', err);
            props.toast.error('Failed to get workers!');
        } finally {
            props.setLoading(false);
        };
    };

    const clearWorkerSearch = async () => {
        setName('');
        setStatus('');
        setWorkers([]);
    };

    const exportWorkers = async () => {
        const today = new Date();
        const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear().toString().slice(-2)}`;
        let data = [
            ["name", "warehouse", "timecard_num", "payroll_num"].join(",")
        ];
        for (let worker of workers) {
            data.push(
                [worker.worker_name, worker.warehouse, worker.timecard_num, worker.payroll_num].join(",")
            );
        };
        let csv = data.join("\n");
        let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        let a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", `${formattedDate} Workers.csv`);
        document.body.appendChild(a);
        a.click();
    };

    return (
        <Box className = {props.isMobile ? "mobile-top" : "desktop-top"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 2}}>
                <h1>Workers</h1>
                <WorkersForm
                    isMobile = {props.isMobile}
                    name = {name}
                    setName = {setName}
                    status_options = {status_options}
                    status = {status}
                    setStatus = {setStatus}
                    clearWorkerSearch = {clearWorkerSearch}
                    getWorkers = {getWorkers}
                    exportWorkers = {exportWorkers}
                    workers = {workers}
                    setOpenInsertWorkerPopup = {setOpenInsertWorkerPopup}
                />
                <WorkersTable 
                    isMobile = {props.isMobile}
                    isLoading = {props.isLoading}
                    setLoading = {props.setLoading}
                    toast = {props.toast}
                    token = {props.token}
                    company = {props.company}
                    workers = {workers}
                    setWorkers = {setWorkers}
                    openEditWorkerPopup = {openEditWorkerPopup}
                    setOpenEditWorkerPopup = {setOpenEditWorkerPopup}
                    selectedRow = {selectedRow}
                    setSelectedRow = {setSelectedRow}
                />
                { openInsertWorkerPopup ? 
                    <InsertWorker 
                        isMobile = {props.isMobile}
                        isLoading = {props.isLoading}
                        setLoading = {props.setLoading}
                        toast = {props.toast}
                        token = {props.token}
                        company = {props.company}
                        open = {openInsertWorkerPopup} 
                        handleClose = {() => setOpenInsertWorkerPopup(false)} 
                    />
                : null }
            </Box>
        </Box>
    );
};

export default Workers;